const toggles = document.querySelectorAll('.footer-nav-section > .h3');

function closeAllExcept(activeCollapsible) {
  const allCollapsibles = document.querySelectorAll('.footer-nav-section > ul');
  allCollapsibles.forEach(function(collapsible) {
    if (collapsible !== activeCollapsible) {
      collapsible.classList.remove('open');
      collapsible.previousElementSibling.classList.remove('active');
    }
  });
}

toggles.forEach(function(toggle) {
  toggle.addEventListener('click', function() {
    if (window.matchMedia('(max-width: 990px)').matches) {
      // Close all sections except the one that was clicked
      closeAllExcept(this.nextElementSibling);

      // Toggle the clicked section
      const collapsible = this.nextElementSibling;
      this.classList.toggle('active');
      collapsible.classList.toggle('open');
    }
  });
});